import { render, staticRenderFns } from "./ReInvesment.vue?vue&type=template&id=1d31218d&scoped=true&"
import script from "./ReInvesment.vue?vue&type=script&lang=js&"
export * from "./ReInvesment.vue?vue&type=script&lang=js&"
import style0 from "./ReInvesment.vue?vue&type=style&index=0&id=1d31218d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31218d",
  null
  
)

export default component.exports